// extracted by mini-css-extract-plugin
export default {"row":"transaction_row__daOmj","date":"transaction_date__HdiCg","status":"transaction_status__JwS06","amount":"transaction_amount__04c3l","balance":"transaction_balance__aa+6t"};